module.exports = __webpack_public_path__ + "img/index2.15fa83c6.jpg";